export const SET_CURRENCY_LIST = 'SET_CURRENCY_LIST';
export const SET_CURRENCY_LOADING = 'SET_CURRENCY_LOADING';

export default {
  SET_CURRENCY_LIST,
  SET_CURRENCY_LOADING,
};
